import { UseBaseMutationResult, useMutation } from '@tanstack/react-query'

import { brand } from '@/utils/brand'

export interface FacebookTokenExchangePayload {
  access_token: string
  frontend_app: boolean
  user_id: string
}

export interface FacebookTokenExchangeResponse {
  account_exists: boolean
  auth_token?: string
  complete?: boolean
  user_id: string
  user_country_code?: string | null
  user_email?: string | null
  user_first_name?: string | null
  user_last_name?: string | null
  user_phone_number?: string | null
}

const exchangeFacebookToken =
  (authBackend: string) =>
  async (payload: FacebookTokenExchangePayload): Promise<FacebookTokenExchangeResponse> => {
    const response = await fetch(`${authBackend}/auth/facebook/credentials/callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to post facebookAuth')
    }

    return response.json()
  }

const useExchangeFacebookToken = (): UseBaseMutationResult<
  FacebookTokenExchangeResponse,
  Error,
  FacebookTokenExchangePayload,
  unknown
> => {
  const authBackend = process.env.NEXT_PUBLIC_AUTH_BACKEND || `https://www.staging.${brand.key}.com`

  return useMutation<FacebookTokenExchangeResponse, Error, FacebookTokenExchangePayload>({
    mutationFn: exchangeFacebookToken(authBackend),
  })
}

export default useExchangeFacebookToken
